import { isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { map, mergeMap, catchError, of } from 'rxjs';

import * as PermissionActions from './permission.actions';
import { ENVIRONMENT } from '../../../enviroment/enviroment';
import type { ApiResponse } from '../../models/api-response';
import type { Profile } from '../../models/profile';
import { toCamelCase } from '../../shared/utilities/case-conversion';

@Injectable()
export class PermissionEffects {
  actions$ = inject(Actions);
  platformId = inject(PLATFORM_ID);
  http = inject(HttpClient);
  baseUrl = ENVIRONMENT.ANGULAR_APP_API_URL;

  loadUserProfile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PermissionActions.loadUserProfile),
      mergeMap(() => {
        // Fetch token from local storage
        let token = '';
        if (isPlatformBrowser(this.platformId)) {
          token = localStorage.getItem('token') || '';
        }
        const headers = new HttpHeaders({ authorization: `${token}` });
        const apiUrl = `${this.baseUrl}onboarding/customer/get-user-details`;

        return this.http.post<ApiResponse<Profile>>(apiUrl, {}, { headers }).pipe(
          map((response) => {
            return PermissionActions.loadUserProfileSuccess({
              profile: toCamelCase(response.data) as Profile,
            });
          }),
          catchError((error) => {
            if (error?.status === 401) {
              localStorage.clear();
              window.location.reload();
            }
            return of(PermissionActions.loadUserProfileFailure({ error }));
          })
        );
      })
    )
  );
}
